"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenTradeComplete = void 0;
var typeorm_1 = require("typeorm");
var OpenTrade_entity_1 = require("./OpenTrade.entity");
var Team_entity_1 = require("./Team.entity");
var OpenTradeComplete = /** @class */ (function () {
    function OpenTradeComplete() {
    }
    __decorate([
        (0, typeorm_1.PrimaryGeneratedColumn)(),
        __metadata("design:type", Number)
    ], OpenTradeComplete.prototype, "id", void 0);
    __decorate([
        (0, typeorm_1.Column)({ default: 'OpenTradeComplete' }),
        __metadata("design:type", String)
    ], OpenTradeComplete.prototype, "type", void 0);
    __decorate([
        (0, typeorm_1.ManyToOne)(function () { return OpenTrade_entity_1.OpenTrade; }, function (trade) { return trade.id; }),
        __metadata("design:type", OpenTrade_entity_1.OpenTrade)
    ], OpenTradeComplete.prototype, "openTrade", void 0);
    __decorate([
        (0, typeorm_1.ManyToOne)(function () { return Team_entity_1.BaseTeam; }, function (team) { return team.teamID; }),
        (0, typeorm_1.JoinColumn)({ name: 'receivingTeam' }),
        __metadata("design:type", Team_entity_1.BaseTeam)
    ], OpenTradeComplete.prototype, "receivingTeam", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", Number)
    ], OpenTradeComplete.prototype, "volume", void 0);
    __decorate([
        (0, typeorm_1.CreateDateColumn)(),
        __metadata("design:type", Date)
    ], OpenTradeComplete.prototype, "tradedAt", void 0);
    OpenTradeComplete = __decorate([
        (0, typeorm_1.Entity)({ name: 'open_trade_complete' })
    ], OpenTradeComplete);
    return OpenTradeComplete;
}());
exports.OpenTradeComplete = OpenTradeComplete;
//# sourceMappingURL=OpenTradeComplete.entity.js.map